// src/components/AuthActivity/OutcomeBadge/OutcomeBadge.js

import React from "react";
import "./OutcomeBadge.css";

const OutcomeBadge = ({ outcome }) => (
  <span className={`outcome-badge outcome-badge--${outcome}`}>
    {outcome}
  </span>
);

export default OutcomeBadge;